module.exports = __webpack_public_path__ + "img/469-2efd13.png";